import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 * Order Payment Form context will wrap all children components and be available as merged props
 */
export const OrderPaymentFormContextInstance = createEmptyContext();
/**
 * Utility method to create `OrderPaymentFormContext` object from `OrderPaymentFormProps`.
 */
export function mapOrderPaymentFormContext(props, onPaymentSuccessful, onPaymentFailed) {
    return Object.assign(Object.assign({}, props), { onPaymentSuccessful,
        onPaymentFailed });
}
